import CRUDService from './crud-service';
import {UserConnection} from 'src/types/user-connections';

export default new CRUDService<UserConnection>('/v1/user-connections');
